import React, { useState } from 'react';
import Button from './FilterButtons';
import { data } from './FiltersData'
import { useGlobalContext } from '../context';

function Filters({ setSelectedCards }) { //Passes in the function to update the state of selectedCards in Home
  const { cards } = useGlobalContext(); //Imported cards fetched from api
  const [filters, setFilters] = useState(data); //Set state of filters to the imported data

  //Vars defined to be used for counting each type of filter selected 
  let elementCount = 0;
  let rarityCount = 0;
  let typeCount = 0;
  let editionCount = 0;

  let selectedCards;

  function onFilterClick(id) { //Receives ID from onClick in FilterButtons
    const newFilters = [...filters]; //Backup data as newFilters

    //Defines filter as an object by searching each object in newFilters for the 'id' property that matches the id passed from the onClick
    const filter = newFilters.find((item) => item.id === id);

    filter.selected = !filter.selected; //Toggle property 'selected' between true/false on each click
    setFilters(newFilters); //Update newFilters with updated 'selected' value
    storeSelected(); // Call the storeSelected function
  }

  const storeSelected = () => {
    let storeFilter = []; //Store the filter (Fire, Rare, Summoner, etc)
    let storeFilterType = []; //Store the type of filter (element, rarity, type, etc)

    //Fills 'selected' array with filter objects that have the 'selected' property of true
    const selected = filters.filter((item) => item.selected === true);

    //Searches 'selected' array for filter name (Fire, Rare, etc) and stores the name in storeFilter array
    selected.map((item) => storeFilter.push(item.filter));
    console.log(storeFilter)
    //Searches 'selected' array to see if filterType array includes each type of filter and counts how many times they occur
    //This basically calculates how many filter buttons the user has selected for each filter category
    selected.forEach((item) => {
      if (item.filterType === 'element') {
        if (storeFilterType.includes(item.filterType)) {
          elementCount += 1;
        } else {
          elementCount += 1;
        }
      }
      if (item.filterType === 'rarity') {
        if (storeFilterType.includes(item.filterType)) {
          rarityCount += 1;
        } else {
          rarityCount += 1;
        }
      }
      if (item.filterType === 'type') {
        if (storeFilterType.includes(item.filterType)) {
          typeCount += 1;
        } else {
          typeCount += 1;
        }
      }
      if (item.filterType === 'edition') {
        if (storeFilterType.includes(item.filterType)) {
          editionCount += 1;
        } else {
          editionCount += 1;
        }
      }
      storeFilterType.push(item.filterType); //Stores the filterType (element, rarity, type, etc) in an array
    });
    //Call the filterSelected function and pass in the storeFilter array which contains each filter name thats been selected
    filterSelected(storeFilter);
  };

  const filterSelected = (storeFilter) => {
    //Sets the selected cards to none each time a new filter is clicked
    selectedCards = [];

    //Logic for displaying the correct filtered cards
    //If only one filter type has been selected
    if (
      (elementCount > 0 && rarityCount === 0 && typeCount === 0 && editionCount === 0) ||
      (elementCount === 0 && rarityCount > 0 && typeCount === 0 && editionCount === 0) ||
      (elementCount === 0 && rarityCount === 0 && typeCount > 0 && editionCount === 0) ||
      (elementCount === 0 && rarityCount === 0 && typeCount === 0 && editionCount > 0)
    ) {
      //Search all cards for this criteria
      cards.forEach((item) => {
        if (
          storeFilter.includes(item.element) ||
          storeFilter.includes(item.rarity) ||
          storeFilter.includes(item.type) ||
          (storeFilter.includes(item.editions[0]) || storeFilter.includes(item.editions[1])) //Check for Alpha & Beta
        ) {
          console.log(item)
          selectedCards.push(item); //Store each card (object) that meets the criteria in to selectedCards array
        }
      });
    }

    //If at least one filter selected for two different filter types
    if (
      (elementCount > 0 && rarityCount > 0 && typeCount === 0 && editionCount === 0) ||
      (elementCount === 0 && rarityCount > 0 && typeCount > 0 && editionCount === 0) ||
      (elementCount > 0 && rarityCount === 0 && typeCount > 0 && editionCount === 0) ||
      (elementCount > 0 && rarityCount === 0 && typeCount === 0 && editionCount > 0) ||
      (elementCount === 0 && rarityCount > 0 && typeCount === 0 && editionCount > 0) ||
      (elementCount === 0 && rarityCount === 0 && typeCount > 0 && editionCount > 0)
    ) {
      cards.forEach((item) => {
        if (
          (storeFilter.includes(item.element) && storeFilter.includes(item.rarity)) ||
          (storeFilter.includes(item.element) && storeFilter.includes(item.type)) ||
          (storeFilter.includes(item.element) && (storeFilter.includes(item.editions[0]) || storeFilter.includes(item.editions[1]))) ||
          (storeFilter.includes(item.rarity) && (storeFilter.includes(item.editions[0]) || storeFilter.includes(item.editions[1]))) ||
          ((storeFilter.includes(item.editions[0]) || storeFilter.includes(item.editions[1])) && storeFilter.includes(item.type)) ||
          (storeFilter.includes(item.rarity) && storeFilter.includes(item.type))          
          ) {
            if (!selectedCards.includes(item)){
              selectedCards.push(item);
            } 
          }
      });
    }

    //If at least one filter selected for three different filter types
    if (
      (elementCount > 0 && rarityCount > 0 && typeCount > 0 && editionCount === 0) ||
      (elementCount === 0 && rarityCount > 0 && typeCount > 0 && editionCount > 0) ||
      (elementCount > 0 && rarityCount > 0 && typeCount === 0 && editionCount > 0) ||
      (elementCount > 0 && rarityCount === 0 && typeCount > 0 && editionCount > 0) 
    ) {
      cards.forEach((item) => {
        if (
          (storeFilter.includes(item.element) && storeFilter.includes(item.rarity) && storeFilter.includes(item.type)) ||
          (storeFilter.includes(item.element) && storeFilter.includes(item.type) && (storeFilter.includes(item.editions[0]) || storeFilter.includes(item.editions[1]))) ||
          (storeFilter.includes(item.element) && storeFilter.includes(item.rarity) && (storeFilter.includes(item.editions[0]) || storeFilter.includes(item.editions[1]))) ||
          (storeFilter.includes(item.type) && storeFilter.includes(item.rarity) && (storeFilter.includes(item.editions[0]) || storeFilter.includes(item.editions[1])))          
          ) {
            if (!selectedCards.includes(item)){
              selectedCards.push(item);
            } 
          }
      });
    }

    //If at least one filter selected for all filter types
    if (elementCount > 0 && rarityCount > 0 && typeCount > 0) {
      cards.forEach((item) => {
        if (
          storeFilter.includes(item.element) &&
          storeFilter.includes(item.rarity) &&
          storeFilter.includes(item.type) &&
          (storeFilter.includes(item.editions[0]) || storeFilter.includes(item.editions[1]))
        ) {
          selectedCards.push(item);
        }
      });
    }

    //If user selected a filter that retrieved no results (ex: Neutral + Summoner) set selectedCards to undefined
    if (storeFilter.length > 0 && selectedCards.length === 0) {
      selectedCards = undefined;
    }

    if (storeFilter.length === 0){
      selectedCards = cards;
    }

    setSelectedCards(selectedCards); //Update state of selected cards in Home to be shared to CardList
  };

  //Grabs each object from the data and stores them into their own array by filterType
  const edition = filters.filter((item) => item.filterType === 'edition');
  const elements = filters.filter((item) => item.filterType === 'element');
  const rarity = filters.filter((item) => item.filterType === 'rarity');
  const type = filters.filter((item) => item.filterType === 'type');

  return (
    <>
      <div className="buttonContainer">
        <div className="editionContainer">
          {/* Creates a button for each filter in the 'rarity' array */}
          {edition.map((item) => (
            // Allows FilterButtons to access "filter" var & onFilterClick() function
            <Button key={item.id} filter={item} onClick={onFilterClick} />
          ))}
        </div>
        <div className="rarityContainer">
          {/* Creates a button for each filter in the 'rarity' array */}
          {rarity.map((item) => (
            // Allows FilterButtons to access "filter" var & onFilterClick() function
            <Button key={item.id} filter={item} onClick={onFilterClick} />
          ))}
        </div>
        <div className="eleContainer">
          {/* Creates a button for each filter in the 'elements' array */}
          {elements.map((item) => (
            // Allows FilterButtons to access "filter" var & onFilterClick() function
            <Button key={item.id} filter={item} onClick={onFilterClick} />
          ))}
        </div>
        <div className="typeContainer">
          {/* Creates a button for each filter in the 'type' array */}
          {type.map((item) => (
            // Allows FilterButtons to access "filter" var & onFilterClick() function
            <Button key={item.id} filter={item} onClick={onFilterClick} />
          ))}
        </div>
      </div>
    </>
  );
}

export default Filters;
